import { render, staticRenderFns } from "./Customize.vue?vue&type=template&id=91d4c9ae&lang=pug&"
import script from "./Customize.vue?vue&type=script&lang=js&"
export * from "./Customize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports